<template>
  <div class="wheels-basic-component" @click="handleClick">My Component from wheels {{ message }}</div>
</template>

<script setup lang="ts">
import { defineProps, onMounted } from 'vue'

defineProps<{
  message?: string
}>()

onMounted(() => {
  console.log('BasicComponent mounted')
})


function handleClick() {
  emit('update', 'wheels-basic-component was clicked')
}

const emit = defineEmits<{
  (e: 'update', message: string): void
}>()

</script>

<style scoped>
.wheels-basic-component {
  color: var(--cu-blue-primary);
}
</style>
